export const ADD_TO_CART = 'ADD_TO_CART';
export const PURCHASE_CD = 'PURCHASE_CD';
export const DOWNLOAD = 'DOWNLOAD';
export const NOT_AVAILABLE_IN_SITE = 'NOT_AVAILABLE_IN_SITE';
export const DISCONTINUED = 'DISCONTINUED';
export const NOT_AVAILABLE = 'NOT_AVAILABLE';
